import { FC, useState } from "react";
import { useLocation } from "react-router-dom";
import { CameraIcon, TriangleAlertIcon } from "lucide-react";

import FacialSelfEnrollDialog from "@/Components/FacialSelfEnrollDialog";

import { useMyFaceStore } from "@/Store";

import S from "./styles.module.scss";

interface FacialEnrollmentBannerProps {}

const SILENT_PATHS = ["/meu-ponto"];

const FacialEnrollmentBanner: FC<FacialEnrollmentBannerProps> = () => {
  const { pathname } = useLocation();
  const hasFacialEnrollment = useMyFaceStore(
    (state) => state.hasFacialEnrollment
  );
  const myEmployeeId = useMyFaceStore((state) => state.myEmployeeId);
  const setMyFacialStatus = useMyFaceStore((state) => state.setMyFacialStatus);

  const [enrolling, setEnrolling] = useState(false);

  if (hasFacialEnrollment !== false) return null;
  if (SILENT_PATHS.some((path) => pathname.startsWith(path))) return null;

  return (
    <>
      <div className={S.banner} role="alert">
        <TriangleAlertIcon size={20} aria-hidden="true" />
        <div className={S.text}>
          <strong>Cadastre o seu reconhecimento facial</strong>
          <span>
            Sem ele você não consegue bater o ponto pela câmera. Leva menos de
            um minuto.
          </span>
        </div>
        <button
          type="button"
          className={S.action}
          onClick={() => setEnrolling(true)}
        >
          <CameraIcon size={16} aria-hidden="true" />
          Cadastrar agora
        </button>
      </div>

      {enrolling && (
        <FacialSelfEnrollDialog
          onClose={() => setEnrolling(false)}
          onEnrolled={() => setMyFacialStatus(myEmployeeId, true)}
        />
      )}
    </>
  );
};

export default FacialEnrollmentBanner;
